export const CARS_VENDOR = 'DELTA_CARS';
export const DEFAULT_PICKUP_TIME = '10:00';
export const DEFAULT_DROPOFF_TIME = '10:00';
export const SEARCH = 'Search';
